import { WidgetContainer } from "@expert/sales-tools";
import { Flex } from "@mantine/core";
import { ErrorBoundary, withErrorBoundary } from "react-error-boundary";

import { RenderError } from "@/shared-utils";
import { Transcript } from "@/transcript/Transcript";

const TranscriptHandled = withErrorBoundary(Transcript, { FallbackComponent: RenderError });

interface WorkspaceContentLeftSidebarSlotProps {
    showRealtimeTranscript: boolean;
    taskStartTimeInMs: number;
}

export function WorkspaceContentLeftSidebarSlot({
    showRealtimeTranscript,
    taskStartTimeInMs,
}: WorkspaceContentLeftSidebarSlotProps) {
    return (
        <Flex pos={"absolute"} inset={0}>
            {showRealtimeTranscript ? (
                <TranscriptHandled taskStartTimeInMs={taskStartTimeInMs} />
            ) : (
                <ErrorBoundary fallback={<RenderError />}>
                    <WidgetContainer />
                </ErrorBoundary>
            )}
        </Flex>
    );
}
